import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Dashboard} from '@/model/resource/Dashboard'

export class ListDashboardSchema extends Schema {
  readonly name = 'ListDashboard'

  readonly fieldSet: FieldSet<Dashboard> = {
    qtdEntregadores: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdEntregadores ?? '',
      },
    }),
    qtdNotasInseridasApp: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasInseridasApp ?? '',
      },
    }),
    qtdNotasInseridasPainel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasInseridasPainel ?? '',
      },
    }),
    qtdNotasInseridasIntegracao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasInseridasIntegracao ?? '',
      },
    }),
    totalNotasInseridas: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.totalNotasInseridas,
      },
    }),
    qtdNotasFinalizadasApp: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasFinalizadasApp ?? '',
      },
    }),
    qtdNotasFinalizadasPainel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasFinalizadasPainel ?? '',
      },
    }),
    qtdNotasFinalizadasIntegracao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasFinalizadasIntegracao ?? '',
      },
    }),
    totalNotasFinalizadas: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.totalNotasFinalizadas ?? '',
      },
    }),
    qtdNotasCanceladas: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdNotasCanceladas ?? '',
      },
    }),
    qtdSmsDisparado: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdSmsDisparado ?? '',
      },
    }),
    qtdResponsaveis: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdResponsaveis ?? '',
      },
    }),
    qtdResponsaveisUltimos30Dias: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.qtdResponsaveisUltimos30Dias ?? '',
      },
    }),
  }
}
